<template lang="pug">
b-modal#adjustMember(
  ref="adjustMember"
  :title="$t('ui.combine.adjust_member')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      //- DebounceInput(
      //-   size="sm"
      //-   ref="account_id"
      //-   required
      //-   type="text"
      //-   :dirty="$v.account_id.$dirty"
      //-   :error="$v.account_id.$error"
      //-   v-model.trim.lazy="$v.account_id.$model"
      //-   :disabled="loading"
      //- )
      //- ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      .disabled-input.form-control.form-control-sm
        span {{ account_id }}
        div.float-right
          span.font-weight-bold(:class="$helpers.fontClassName(game_balance)") {{ $n(game_balance, 'currency') }}

    b-form-group(:label="$t('ui.type')").mb-0
      AdjustBalance(
        ref="adjust_type"
        size="sm"
        required
        type="text"
        :dirty="$v.adjust_type.$dirty"
        :error="$v.adjust_type.$error"
        v-model.trim.lazy="$v.adjust_type.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.adjust_type" :name="$t('ui.type')")
    b-form-group(:label="$t('ui.amount')").mb-0
      DebounceInput(
        size="sm"
        ref="amount"
        type="text"
        :dirty="$v.amount.$dirty"
        :error="$v.amount.$error"
        v-model.trim.lazy="$v.amount.$model"
        :disabled="loading"
      )
      //- span.small.text-info {{ $t('message.adjust_amount_member_tooltip') }}
      ValidateResult(:value="$v.amount" :name="$t('ui.amount')")
    b-form-group(:label="$tc('ui.remark')").mb-0
      DebounceInput(
        size="sm"
        ref="remark"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, minValue, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import AdjustBalance from "@/library/AdjustBalance";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    AdjustBalance
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      account_id: "",
      game_balance: "",
      amount: "",
      remark: "",
      adjust_type: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    // account_id: {
    //   required,
    //   alphaNum,
    //   minLength: minLength(6),
    //   maxLength: maxLength(20)
    // },
    remark: {
      required
    },
    adjust_type: {
      required
    },
    amount: {
      required,
      decimal,
      minValue: minValue(0)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.memberWalletAdjustUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          amount: this.adjust_type == "add_balance" ? this.amount : this.amount * -1,
          remark: this.remark
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.adjustMember.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "adjust_balance", this.feedback.status);
                  this.$refs.adjustMember.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      if(this.item.wallet != null && this.item.wallet.game_balance != null)
        this.game_balance = this.item.wallet.game_balance
      else
        this.game_balance = ''
      this.adjust_type = "";
      this.amount = "";
      this.remark = "";
      this.$refs.amount.$el.focus();
    }
  }
};
</script>

<style scoped>
.disabled-input {
  background-color: #e9ecef;
  opacity: 1;
}
</style>